import ActionApi from 'app/developer-v3/pages/actions/ActionApi';
import ActionDynamicInputEditor from 'app/developer-v3/pages/actions/ActionDynamicInputEditor';
import ActionEditor from 'app/developer-v3/pages/actions/ActionEditor';
import ActionInputEditor from 'app/developer-v3/pages/actions/ActionInputEditor';
import ActionInputs from 'app/developer-v3/pages/actions/ActionInputs';
import ActionInputsList from 'app/developer-v3/pages/actions/ActionInputsList';
import ActionSettings from 'app/developer-v3/pages/actions/ActionSettings';
import Actions from 'app/developer-v3/pages/actions';
import ActionGroupInputEditor, {
  ActionGroupChildInputEditor,
  ActionGroupParentInputEditor,
} from 'app/developer-v3/pages/actions/ActionGroupInputEditor';
import { getActionUrl, isNewServiceField } from 'app/developer-v3/utils';

export default {
  // We don't assign serviceType here since it could be creates or searches
  routes: {
    '.': Actions,
    ':actionType': {
      routes: {
        ':actionKey': {
          component: ActionEditor,
          routes: {
            '.': {
              onEnter({ router, routeTo }) {
                routeTo(`${getActionUrl(router.next.params)}/settings`);
              },
            },
            settings: {
              component: ActionSettings,
            },
            input: {
              component: ActionInputs,
              onEnter({ router, routeTo }) {
                if (isNewServiceField(router.next.params.actionKey)) {
                  routeTo(`${getActionUrl(router.next.params)}/settings`);
                }
              },
              routes: {
                '.': ActionInputsList,
                ':inputKey': {
                  routes: {
                    '.': ActionInputEditor,
                    dynamic: ActionDynamicInputEditor,
                    'line-item': {
                      component: ActionGroupInputEditor,
                      routes: {
                        '.': ActionGroupParentInputEditor,
                        ':childInputKey': ActionGroupChildInputEditor,
                      },
                    },
                  },
                },
              },
            },
            api: {
              component: ActionApi,
              onEnter({ router, routeTo }) {
                if (isNewServiceField(router.next.params.actionKey)) {
                  routeTo(`${getActionUrl(router.next.params)}/settings`);
                }
              },
            },
          },
        },
      },
    },
  },
};
